import React from "react";
import { Button, ButtonGroup } from "reactstrap";
import classNames from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import styles from "./styles.scss";

export interface SegmentedToggleOption {
  value: string;
  label: string;
}

interface Props {
  title: string;
  value: string;
  options: [SegmentedToggleOption, SegmentedToggleOption];
  onChange: (value: string) => void;
  disabled?: boolean;
  showInfo?: boolean;
  infoId?: string;
  compact?: boolean;
  centered?: boolean;
  hideTitle?: boolean;
  className?: string;
}

const SegmentedToggle: React.FC<Props> = ({
  title,
  value,
  options,
  onChange,
  disabled = false,
  showInfo = false,
  infoId = "segmentedToggle",
  compact = false,
  centered = false,
  hideTitle = false,
  className,
}) => (
  <div
    className={classNames(
      compact ? styles.rootCompact : styles.root,
      centered && styles.rootCentered,
      hideTitle && styles.rootInline,
      className
    )}
  >
    {!hideTitle && (
      <span className={styles.title}>
        {title}
        {showInfo && (
          <span data-tip data-for={`tp${infoId}`}>
            <i className="fa fa-question-circle" />
          </span>
        )}
      </span>
    )}
    <ButtonGroup className={styles.buttonGroup}>
      {options.map(option => (
        <Button
          key={option.value}
          type="button"
          color="none"
          className={classNames(
            compact ? styles.toggleBtnCompact : styles.toggleBtn,
            value === option.value && styles.toggleBtnActive
          )}
          onClick={() => onChange(option.value)}
          disabled={disabled}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  </div>
);

export default withStyles(styles)(SegmentedToggle);
